import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import QrCodeScanner from "../../../common/QrCodeScanner";
import { Row, Col } from "react-bootstrap";

const AcknowledgeModal = (props) => {
  // eslint-disable-next-line
  let [edit, setEdit] = useState(false);
  let [qrOpen, setQROpen] = useState(false);
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setQROpen(true);
  }, []);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };
  const handleClick = () => {
    props.onButtonClick(inputValue,'from'); // Send input value to parent component
  };

  const { show, onHide } = props;
  return (
    <>
      <Modal
        show={show}
        size="lg"
        className="jobcard-qrscanner-modal"
        onHide={onHide}
        animation={false}
        backdrop="static"
      >
        <ModalHeader
          title={t("msg_trasaction.msg_teamlead_acknowledge.page_title")}
        ></ModalHeader>
        <ModalBody>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "90vh",
            }}
          >
            <div
              style={{
                width: "80%",
                height: "auto",
                border: "2px solid black",
                padding: "10px",
              }}
            >
              {qrOpen && (
                <QrCodeScanner
                  onSuccess={props.handleSuccess}
                  onError={props.handleError}
                  qrbox={{ width: 250, height: 250 }} // Reduced qrbox size
                />
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col xs={8} md={8}>
              <form className="manual-jobcard-form">
                <label htmlFor="fname">Enter JobCard Manually : </label>
                <input
                  type="text"
                  id="fname"
                  value={inputValue}
                  onChange={handleInputChange}
                  name="fname"
                />
              </form>
            </Col>
            <Col xs={4} md={4}>
              <Button
                type="button"
                variant="success"
                className="btn btn-success"
                onClick={handleClick}
              >
                {"SUBMIT"}
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AcknowledgeModal;
